import axios from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { __API_URL__ } from "../SERVER_URL";

const useAddTrialMutation = () => {
  const queryClient = useQueryClient();
  const token = localStorage.getItem("token");

  return useMutation({
    mutationFn: async (trialData) => {
      const response = await axios.post(`${__API_URL__}/api/photos/add_trial/`, trialData, {
        headers: { Authorization: `Token ${token}` },
      });
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["trials_list"] });
    },
  });
};

export default useAddTrialMutation;
